/* eslint-disable */
<template>
  <div class="Swiperdemo" v-bind:style="{ paddingBottom: $store.state.paddingBottom + 'px' }">

    <keep-alive>
      <NavigationBar>
        <template v-slot:left>
          <img v-on:click="goBack" class="back" src="../assets/icons/ic_16_back.svg" data-testid="nav-back">
        </template>
        <template v-slot:center>
          <span data-testid="swiper-demo-title">Swiper Vue2</span>
        </template>
      </NavigationBar>
    </keep-alive>

    <div class="swiper" id="swiper_container">
      <WelcomeSwiper></WelcomeSwiper>
    </div>
  </div>
</template>

<script>

import WelcomeSwiper from './../components/WelcomeSwiper.vue'
import NavigationBar from './../components/NavigationBar'

export default {
  name: 'swiperdemo2',
  components: { WelcomeSwiper, NavigationBar },
  created () {
  },
  methods: {
    goBack () {
      this.$router.push({ name: 'profile' }).catch(err => {
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@media screen and (max-width: 414px) {
  .swiper {
    margin: 16px 0;
  }
}
</style>
